import { useEffect, useMemo } from "react";
import { ADMIN_PAGES, MANAGER_PAGES, STAFF_PAGES } from "../constants";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

const Page404 = ({ user }) => {
  const navigate = useNavigate();

  const allowedPages = useMemo(() => {
    if (user.role === "admin") {
      return ADMIN_PAGES;
    } else if (user.role === "manager") {
      return MANAGER_PAGES;
    } else if (user.role === "staff") {
      return STAFF_PAGES;
    } else {
      return [];
    }
  }, [user]);

  useEffect(() => {
    if (
      !allowedPages.some((page) => window.location.pathname.includes(page.link))
    ) {
      if (allowedPages[0] && allowedPages[0].link) {
        navigate(`/__admin/${allowedPages[0].link}`);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allowedPages, user]);

  return (
    <div className="flex flex-col">
      <CircularProgress />
    </div>
  );
};

export default Page404;
